/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BookPublicEventPaymentPayload = {
    type: BookPublicEventPaymentPayload.type;
    orderId?: string;
};
export namespace BookPublicEventPaymentPayload {
    export enum type {
        ONLINE = 'online',
        CASH = 'cash',
        INVOICE = 'invoice',
    }
}

